export default {
  'price.title': 'Цена',
  'price.originalPrice': 'Исходная цена',
  'price.currency': 'Валюта',
  'price.originalPriceError': 'Исходная цена обязательна',
  'price.discountedPrice': 'Цена со скидкой',
  'price.discountBy': 'Скидка',
  'price.discountedCalc': 'Будет рассчитано',
  'price.discounted': 'Со скидкой?',
  'price.trialed': 'Пробный период?',
  'price.duration': 'Период оплаты',
  'price.durationPeriod': 'Период',
  'price.discount': 'Скидка',
  'price.trialedDiscount': 'Скидка пробного периода',
  'price.discountInfo': 'Информация о скидке {{header}}',
  'price.discountStartedAt': 'Начало',
  'price.discountDuration': 'Длительность скидки',
  'price.trial': 'Пробный',
  'price.sale': 'Распродажа',
  'price.saleAt': 'Начало / окончание распродажи',
  'price.trialDuration': 'Длительность пробного периода',
  'price.trialPriceInfo': 'Пробный период',
  'price.priceInfo': 'Информация о цене {{type}}',
  'price.info.helper':
    'Задайте исходную цену, выберите валюту, примените скидки и определите параметры пробного периода',
};
